import { ChangeDetectionStrategy, Component, Input, inject } from "@angular/core";
import { AuditQuestionnaireComponent, AuditResponseChange } from "../audit-questionnaire/audit-questionnaire.component";
import { AuditQuestion, AuditSection } from "../../models/lab-audit.models";
import { LabAuditStateService } from "../../services/lab-audit-state.service";

@Component({
  selector: "app-audit-section-tab",
  standalone: true,
  imports: [AuditQuestionnaireComponent],
  template: `
    <app-audit-questionnaire
      [title]="title"
      [questions]="questions"
      [responses]="auditState.audit()[section].responses"
      [score]="score"
      [maximumScore]="maximumScore"
      [additionalComments]="auditState.audit()[section].additionalComments"
      (responseChange)="updateResponse($event)"
      (cleanConfirmed)="auditState.resetSection(section)"
      (additionalCommentsChange)="auditState.updateAdditionalComments(section, $event)">
    </app-audit-questionnaire>
  `,
  styles: [":host { display: block; height: 100%; min-height: 0; }"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuditSectionTabComponent {
  @Input({ required: true }) title = "";
  @Input({ required: true }) questions: AuditQuestion[] = [];
  @Input({ required: true }) section!: AuditSection;
  @Input() score = 0;
  @Input() maximumScore = 0;
  readonly auditState = inject(LabAuditStateService);

  updateResponse(change: AuditResponseChange): void {
    this.auditState.updateResponse(this.section, change.questionId, change.changes);
  }
}